/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from "@fortawesome/free-solid-svg-icons";

// component
import ModalNotify from '../../../../features/ModalNotify';
import { actModalChange, actComponentsModal, actModalIsOk, actResetModal } from '../../../../actions/modal';
import { sumTable, datePickup, surveyReport } from '../../../../redux/actions';
import { showLoading, hideLoading } from '../../../../actions/ui';
import { changeHeader } from '../../../../actions/header';
import MultiBranchSelect from '../../../../features/MultiBranchSelect';
import { decreaseOneMonthYYYY_MM, checkMonthWithOther2Day, getTodayMonth, } from '../../../../utils/Date/SupportDate'
import { coverNameToID } from '../../../../utils/Branch/SupportBranch'
import ModalSurveySentReport from '../../../../components/SurveyOnlineTable/ModalSurveySentReport';
import NoteReport from '../../../../features/NotReport';

// api / support
import * as SupportDate from '../../../../utils/Date/SupportDate';
import * as branchApi from '../../../../api/branchinfor';
import * as surveyApi from '../../../../api/other/survey';
import * as rotenSurveyApi from '../../../../api/other/rotenReport';

import './survey.css'
import NewSurveyOnlineItems from '../../../../components/SurveyOnlineTable/NewSurveyOnlineItems';
import NewSurveyOnlineReport from '../../../../components/SurveyOnlineTable/NewSurrveyOnlineReport';
import ModalSupportOption from '../../../../components/SupportComponents/Modal/ModalOption';
import RotenSurveyReport from '../../../../components/SurveyOnlineTable/RotenSurveyReport';
import MultiMonthStatistic from '../../../../components/SurveyOnlineTable/MultiMonthStatistic';

// Branches not included in survey reports
const EXCLUDED_BRANCH_IDS = [2, 10, 99];

NewSurveyOnline.propTypes = {
};

function NewSurveyOnline() {
    const dispatch = useDispatch();
    const surveyOnlineData = useSelector(state => state.surveyOnline);
    const dataBranchOnState = useSelector(state => state.datepickup.selectSurveyOnline)
    let history = useHistory();

    const allBranchInform = useSelector(state => state.allBranchInformation);
    const auth = useSelector(state => state.auth);
    const token = useSelector(state => state.token);
    const { role, area, branchID } = auth.user;
    const isMultiBranch = (role === 5 || role === 6 || role === 7 || role === 8 || role === 1);
    const isMultiArea = (role === 7 || role === 1 || role === 8);

    var [selectArea, setSelectArea] = useState("Select Area");
    var [selectBranch, setSelectBranch] = useState("Select Branch");
    var saveDataToDatePickUp;

    const [typeView, setTypeView] = useState("RESULT");
    const [activeAreaTab, setActiveAreaTab] = useState("ALL");
    const [areaAllTabData, setAreaAllTabData] = useState(null);
    const [areaBranchTabs, setAreaBranchTabs] = useState([]);
    // Multi-month report
    const [multiMode, setMultiMode] = useState(false);
    const [multiMonths, setMultiMonths] = useState([]);
    const [multiMonthInput, setMultiMonthInput] = useState("");
    const [multiResult, setMultiResult] = useState(null);
    const [multiLoading, setMultiLoading] = useState(false);
    const [includeBranch11, setIncludeBranch11] = useState(false);
    const { branchReport, monthReport } = useParams();
    const listArea = allBranchInform === undefined ? [] : Object.keys(allBranchInform);
    var listBranch = (role === 6) ? renderListBranch(area) : (role === 7 || role === 8) ? renderListBranch(dataBranchOnState.area) : [];

    const todayMonthCheck = checkMonthWithOther2Day(getTodayMonth(), dataBranchOnState.date);
    const decreaMonthCheck = checkMonthWithOther2Day(decreaseOneMonthYYYY_MM(getTodayMonth()), dataBranchOnState.date);
    const checkSend = todayMonthCheck === 0 ? true : (todayMonthCheck === 1 && decreaMonthCheck === 0) ? true : false;

    function round2(value) {
        if (!Number.isFinite(value)) return 0;
        return Math.round(value * 100) / 100;
    }

    function normalizeText(value) {
        if (!value) return "";
        return String(value)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '')
            .toLowerCase();
    }

    function isHaNoiArea(areaValue) {
        const normalized = normalizeText(areaValue);
        return normalized.includes("hanoi");
    }

    function shouldExcludeBranch(branch, areaValue) {
        const branchId = Number(branch?.branchID);
        if (!Number.isFinite(branchId)) return true;
        if (EXCLUDED_BRANCH_IDS.includes(branchId)) return true;
        return isHaNoiArea(areaValue) && branchId === 99;
    }

    function getAllBranchesForLoad() {
        if (!allBranchInform || JSON.stringify(allBranchInform) === '{}') {
            return [];
        }

        return Object.keys(allBranchInform).reduce((result, areaKey) => {
            const areaBranches = Array.isArray(allBranchInform[areaKey]) ? allBranchInform[areaKey] : [];
            areaBranches.forEach(branch => {
                if (!shouldExcludeBranch(branch, areaKey)) {
                    result.push(branch);
                }
            });
            return result;
        }, []);
    }

    function getBranchesInArea(areaValue) {
        if (!allBranchInform || JSON.stringify(allBranchInform) === '{}') {
            return [];
        }

        if (areaValue === "Select Area") {
            return getAllBranchesForLoad();
        }

        const areaBranches = Array.isArray(allBranchInform[areaValue]) ? allBranchInform[areaValue] : [];

        return areaBranches.filter(branch => {
            return !shouldExcludeBranch(branch, areaValue);
        });
    }

    function getAreaSelectedForLoad() {
        return dataBranchOnState.area || "Select Area";
    }

    function getBranchIdsByArea(areaValue) {
        return getBranchesInArea(areaValue)
            .map(branch => Number(branch.branchID))
            .filter(branchId => Number.isFinite(branchId) && branchId > 0);
    }

    function mergeWeekObject(target, source) {
        const weekKeys = ["week1", "week2", "week3", "week4", "week5", "month"];
        weekKeys.forEach(key => {
            const sourceData = Array.isArray(source?.[key]) ? source[key] : [];
            target[key] = [...(target[key] || []), ...sourceData];
        });
    }

    function mergeMetricObject(target, source) {
        if (!source) return;
        Object.keys(source).forEach(key => {
            target[key] = Number(target[key] || 0) + Number(source[key] || 0);
        });
    }

    function addBranchMetaToWeekData(weekData, branchName, branchIDValue) {
        const result = {};
        const weekKeys = ["week1", "week2", "week3", "week4", "week5", "month"];
        weekKeys.forEach(key => {
            const sourceData = Array.isArray(weekData?.[key]) ? weekData[key] : [];
            result[key] = sourceData.map(item => ({
                ...item,
                branchName,
                branchID: Number(branchIDValue),
            }));
        });
        return result;
    }

    function buildAverageWeekFromSurvey(surveyData) {
        const keys = ["week1", "week2", "week3", "week4", "week5", "month"];
        const averageWeek = {};
        const scoreKeys = ["price", "reception", "otherRC", "BF", "speed", "room", "clear", "otherClear", "roten", "massage"];

        keys.forEach(week => {
            const listSurvey = Array.isArray(surveyData[week]) ? surveyData[week] : [];
            const sumCau5 = {
                price: { sum: 0, count: 0 },
                reception: { sum: 0, count: 0 },
                otherRC: { sum: 0, count: 0 },
                BF: { sum: 0, count: 0 },
                speed: { sum: 0, count: 0 },
                room: { sum: 0, count: 0 },
                clear: { sum: 0, count: 0 },
                otherClear: { sum: 0, count: 0 },
                roten: { sum: 0, count: 0 },
                massage: { sum: 0, count: 0 }
            };

            listSurvey.forEach(survey => {
                const question5 = Array.isArray(survey.question5) ? survey.question5 : [];
                const scoreList = [
                    { key: "price", value: Number(question5?.[0]?.answer || 0) },
                    { key: "reception", value: Number(question5?.[1]?.answer || 0) },
                    { key: "otherRC", value: Number(question5?.[2]?.answer || 0) },
                    { key: "BF", value: Number(question5?.[3]?.answer || 0) },
                    { key: "speed", value: Number(question5?.[4]?.answer || 0) },
                    { key: "room", value: Number(question5?.[5]?.answer || 0) },
                    { key: "clear", value: Number(question5?.[6]?.answer || 0) },
                    { key: "otherClear", value: Number(question5?.[7]?.answer || 0) },
                    { key: "roten", value: Number(question5?.[8]?.answer || 0) },
                    { key: "massage", value: Number(question5?.[9]?.answer || 0) },
                ];

                scoreList.forEach(({ key, value }) => {
                    sumCau5[key].sum += value;
                    sumCau5[key].count += value === 0 ? 0 : 1;
                });
            });

            averageWeek[week] = {};
            scoreKeys.forEach(key => {
                averageWeek[week][key] = sumCau5[key].count === 0 ? 0 : round2(sumCau5[key].sum / sumCau5[key].count);
            });
        });

        return averageWeek;
    }

    function buildCalculatorWeekFromAverage(averageWeek) {
        const calculatorWeek = {};
        const weekKeys = ["week1", "week2", "week3", "week4", "week5"];
        const monthSum = {
            reception: 0, azuman: 0, kitchen: 0, hk: 0, roten: 0, massage: 0,
            otherRC: 0, otherClear: 0, server: 0, maintainer: 0, speed: 0, BF: 0,
            room: 0, price: 0, clear: 0
        };
        const monthCount = {
            reception: 0, azuman: 0, kitchen: 0, hk: 0, roten: 0, massage: 0,
            otherRC: 0, otherClear: 0, server: 0, maintainer: 0, speed: 0, BF: 0,
            room: 0, price: 0, clear: 0
        };

        weekKeys.forEach(week => {
            if (!averageWeek[week]) return;

            const current = averageWeek[week];
            calculatorWeek[week] = {
                reception: current.reception,
                azuman: round2((current.otherRC + current.otherClear) / 2),
                kitchen: round2((current.otherRC + current.otherClear + current.BF + current.speed) / 4),
                hk: round2((current.otherRC + current.otherClear + current.clear) / 3),
                roten: current.roten,
                massage: current.massage,
                room: current.room,
                price: current.price,
                clear: current.clear,
                speed: current.speed,
                BF: current.BF,
                otherRC: current.otherRC,
                otherClear: current.otherClear,
                server: round2((current.otherRC + current.otherClear + current.speed) / 3),
                maintainer: round2((current.otherRC + current.room) / 2),
            };

            Object.keys(monthSum).forEach(key => {
                const value = Number(calculatorWeek[week][key] || 0);
                if (value > 0) {
                    monthSum[key] += value;
                    monthCount[key] += 1;
                }
            });
        });

        calculatorWeek.Month = {};
        Object.keys(monthSum).forEach(key => {
            calculatorWeek.Month[key] = monthCount[key] === 0 ? 0 : round2(monthSum[key] / monthCount[key]);
        });

        return calculatorWeek;
    }

    function buildChartDataFromCalculator(calculatorWeek) {
        const labels = ['Reception', 'Azuman', 'Kitchen', 'House Keeping', 'Rotenburo', 'Massage'];
        const weekData = (week) => {
            const source = calculatorWeek?.[week] || {};
            return [
                Number(source.reception || 0),
                Number(source.azuman || 0),
                Number(source.kitchen || 0),
                Number(source.hk || 0),
                Number(source.roten || 0),
                Number(source.massage || 0),
            ];
        }

        return {
            labels,
            datasets: [
                { label: 'Week 1', data: weekData("week1"), backgroundColor: 'rgba(255, 99, 132, 0.5)' },
                { label: 'Week 2', data: weekData("week2"), backgroundColor: 'rgba(53, 162, 235, 0.5)' },
                { label: 'Week 3', data: weekData("week3"), backgroundColor: 'yellow' },
                { label: 'Week 4', data: weekData("week4"), backgroundColor: 'green' },
                { label: 'Week 5', data: weekData("week5"), backgroundColor: 'red' },
            ],
        }
    }

    function buildEmptyOldMonth() {
        return {
            calculatorWeek: {
                Month: {
                    reception: 0,
                    azuman: 0,
                    kitchen: 0,
                    hk: 0,
                    roten: 0,
                    massage: 0,
                }
            }
        }
    }

    function convertPayloadToSurveyView(payload) {
        return {
            content: payload?.survey || {},
            weekReport: payload?.weekReport || {},
            gestOpinion: payload?.gestOpinion || {},
            rotenGuestOpinion: payload?.rotenGuestOpinion || {},
            isLoading: false,
            calculatorWeek: payload?.calculatorWeek || {},
            averageWeek: payload?.averageWeek || {},
            dataChart: payload?.dataChart || {},
            maker: "",
            note: "",
            sendReportDate: "",
            oldMonth: payload?.oldMonth || buildEmptyOldMonth(),
            sumTypeSurvey: payload?.sumTypeSurvey || {},
        }
    }

    function getCurrentAreaTabData() {
        if (!(isMultiBranch && dataBranchOnState.branch === "Select Branch")) {
            return {
                branchID: Number(dataBranchOnState.ID || branchID),
                data: surveyOnlineData,
            };
        }

        if (activeAreaTab === "ALL") {
            return {
                branchID: 0,
                data: areaAllTabData || surveyOnlineData,
            }
        }

        const activeBranchData = areaBranchTabs.find(item => String(item.branchID) === String(activeAreaTab));
        return {
            branchID: Number(activeBranchData?.branchID || 0),
            data: activeBranchData?.data || areaAllTabData || surveyOnlineData,
        };
    }

    // Run one time. 
    useEffect(() => {
        dispatch(changeHeader("/survey_online"));
        const queryParams = window.location.href;
        // If load on long link : full branch, area, day

        const listRealBranch = listBranch.filter(branchName => branchName !== "Select Branch");

        if (role === 6 && listRealBranch.length === 1) {
            setSelectBranch(listRealBranch[0]);
            // change BranchID
            const areaFindIndex = dataBranchOnState.area === "Select Area" ? area : dataBranchOnState.area;
            const findindex = allBranchInform[areaFindIndex].findIndex(({ name }) => name === listRealBranch[0]);
            let branchIdSelect = allBranchInform[areaFindIndex][findindex].branchID;
            saveDataToDatePickUp = {
                ...dataBranchOnState,
                ID: branchIdSelect,
                branch: listRealBranch[0],
            }
            dispatch(datePickup.changeSelectBranchSurveyOnline(saveDataToDatePickUp));
        }

        if (area !== undefined) {
            if (String(queryParams).length > 40) {
                loadDataFormParam();
            } else {
                // if click back when finish load Data -> setup again Selected Branch 
                if (selectBranch === "Select Branch" && surveyOnlineData.loading === false && isMultiBranch) {
                    setSelectBranch(branchIdToName());
                }
            }
        }
    }, [auth, area]);

    function renderListBranch(areaValue) {
        const list = getBranchesInArea(areaValue).map(branch => branch.name);
        return ["Select Branch", ...list];
    }

    function loadDataFormParam() {
        if (String(branchReport).startsWith("area_")) {
            const areaReq = decodeURIComponent(String(branchReport).replace("area_", ""));
            const branchIds = getBranchIdsByArea(areaReq);

            saveDataToDatePickUp = {
                ...dataBranchOnState,
                ID: 0,
                branch: "Select Branch",
                area: areaReq,
                date: monthReport
            }
            dispatch(datePickup.changeSelectBranchSurveyOnline(saveDataToDatePickUp))

            if (branchIds.length > 0) {
                loadSurveyOnlineData(branchIds, monthReport, "Month", true);
            }
            return;
        }

        saveDataToDatePickUp = {
            ...dataBranchOnState,
            date: monthReport
        }
        dispatch(datePickup.changeSelectBranchSurveyOnline(saveDataToDatePickUp))
        onLoadData(branchReport, monthReport, "Month");
    }

    // Buton
    function changeSelectArea(value) {
        setActiveAreaTab("ALL");
        setAreaAllTabData(null);
        setAreaBranchTabs([]);
        saveDataToDatePickUp = {
            ID: 0,
            area: value,
            branch: "Select Branch",
            loadWith: "Month",
            date: dataBranchOnState.date
        }
        dispatch(datePickup.changeSelectBranchSurveyOnline(saveDataToDatePickUp)) //reset select BranchID
    };

    function changeSelectBranchID(value) {
        setActiveAreaTab("ALL");
        if (value === "Select Branch") {
            saveDataToDatePickUp = {
                ...dataBranchOnState,
                ID: 0,
                branch: "Select Branch",
            }
            dispatch(datePickup.changeSelectBranchSurveyOnline(saveDataToDatePickUp));
            return;
        }

        setAreaAllTabData(null);
        setAreaBranchTabs([]);

        // change BranchID
        const areaFindIndex = dataBranchOnState.area === "Select Area" ? area : dataBranchOnState.area;
        const findindex = allBranchInform[areaFindIndex].findIndex(({ name }) => name === value);
        let branchIdSelect = allBranchInform[areaFindIndex][findindex].branchID;
        saveDataToDatePickUp = {
            ...dataBranchOnState,
            ID: branchIdSelect,
            branch: value,
        }
        dispatch(datePickup.changeSelectBranchSurveyOnline(saveDataToDatePickUp));
    };

    function onLoadData(brandReq, monthReq, loadWithReq) {
        const areaSelected = getAreaSelectedForLoad();
        const branchIdsByArea = getBranchIdsByArea(areaSelected);
        const isLoadByArea = isMultiBranch && dataBranchOnState.branch === "Select Branch";

        const loadData = (brandReq, monthReq, loadWithReq) => {
            if (monthReq === 0) {
                openModal("", "NOTIFICATION", "PLEASE SELECT DATE VIEW", "", "OK")
                const changeComponent = actComponentsModal("")
                dispatch(changeComponent);
            } else {
                if ((role >= 5) && selectBranch === "Select Branch" && !isLoadByArea) {
                    openModal("", "NOTIFICATION", "PLEASE SELECT BRANCH", "", "OK")
                    const changeComponent = actComponentsModal("")
                    dispatch(changeComponent);
                } else if (isLoadByArea && branchIdsByArea.length === 0) {
                    openModal("", "NOTIFICATION", "THIS AREA HAS NO BRANCH DATA", "", "OK")
                    const changeComponent = actComponentsModal("")
                    dispatch(changeComponent);
                }
                else {
                    if (isLoadByArea) {
                        saveDataToDatePickUp = {
                            ...dataBranchOnState,
                            ID: 0,
                            area: areaSelected,
                            branch: "Select Branch",
                            date: monthReq,
                            loadWith: "Month"
                        };
                        dispatch(datePickup.changeSelectBranchSurveyOnline(saveDataToDatePickUp));
                        setSelectArea(areaSelected);
                        setSelectBranch("Select Branch");
                        loadSurveyOnlineData(branchIdsByArea, monthReq, loadWithReq, true);
                    } else {
                        loadSurveyOnlineData(brandReq, monthReq, loadWithReq);
                    }
                }
            }
        }

        if (isLoadByArea) {
            return loadData(brandReq, monthReq, loadWithReq);
        }

        // monthCheck = todayMonth -2.
        // if monthCheck > monthReq => can't send report

        const loadBranchNameFromID = async () => {
            const res = await branchApi.getNameBranch(brandReq, token);
            return res.data;
        }

        const loadBranchAreaFromID = async () => {
            const res = await branchApi.getAreaBranch(brandReq, token);
            return res.data;
        }

        loadBranchAreaFromID().then(resArea => {
            if (resArea !== area && (role !== 7 && role !== 8 && role !== 1)) {
                alert("Mistake Branch Area");
                return history.push("/survey_online");
            } else {
                selectArea = resArea;
                setSelectArea(resArea)
                loadBranchNameFromID().then(resBranchName => {
                    let dataSelect = {
                        ID: brandReq,
                        area: resArea,
                        branch: resBranchName,
                        date: monthReq,
                        loadWith: "Month"
                    };
                    dispatch(datePickup.changeSelectBranchSurveyOnline(dataSelect)) //reset select BranchID
                    selectBranch = resBranchName;
                    setSelectBranch(resBranchName);
                    loadData(brandReq, monthReq, loadWithReq);
                });
            }
        });

    }

    function loadSurveyOnlineData(brandReq, monthReq, loadWithReq, isLoadByArea = false) {
        showLoading();
        dispatch(sumTable.resetData());
        const FetchSumData = async () => {
            try {
                dispatch(showLoading());
                dispatch(surveyReport.resetDataSurveyReport());
                const branchListRequest = Array.isArray(brandReq) ? brandReq : [brandReq];
                const queryLoadWith = String(loadWithReq || "Month").toLowerCase() === "month" ? "Month" : loadWithReq;

                const requestList = await Promise.all(
                    branchListRequest.map(async (branchItem) => {
                        const branchTarget = Number(branchItem);
                        const response = await surveyApi.getNewVersionSurvey(branchTarget, queryLoadWith, monthReq, token);
                        const responseOldMonth = await surveyApi.getNewVersionSurvey(branchTarget, queryLoadWith, decreaseOneMonthYYYY_MM(monthReq), token);
                        const responseRotenSurvey = await rotenSurveyApi.getRotenSurvey(branchTarget, monthReq, "roten", token);

                        return {
                            response,
                            responseOldMonth,
                            responseRotenSurvey
                        }
                    })
                );

                const validCurrentResponse = requestList
                    .map(item => item.response?.data)
                    .filter(item => item && item.status === 1);

                if (validCurrentResponse.length === 0) {
                    const errMessage = requestList?.[0]?.response?.data?.msg || "Have note data this Month";
                    dispatch(hideLoading());
                    showToast(errMessage)
                    return;
                }

                if (!isLoadByArea) {
                    setActiveAreaTab("ALL");
                    setAreaAllTabData(null);
                    setAreaBranchTabs([]);
                    const response = requestList[0].response;
                    const responseOldMonth = requestList[0].responseOldMonth;
                    const responseRotenSurvey = requestList[0].responseRotenSurvey;

                    if (responseOldMonth.data.calculatorWeek === undefined) {
                        response.data.oldMonth = buildEmptyOldMonth();
                    } else {
                        response.data.oldMonth = responseOldMonth.data;
                    }

                    dispatch(hideLoading());
                    if (response.data.status === 0) showToast(response.data.msg)
                    else dispatch(surveyReport.fetchSurveyReport({
                        ...response.data,
                        rotenGuestOpinion: responseRotenSurvey.data.filterResult
                    }));
                    return;
                }

                const mergedSurvey = { week1: [], week2: [], week3: [], week4: [], week5: [], month: [] };
                const mergedGuestOpinion = { week1: [], week2: [], week3: [], week4: [], week5: [] };
                const mergedRotenOpinion = { week1: [], week2: [], week3: [], week4: [], week5: [] };
                const mergedSumTypeSurvey = { app: 0, public1: 0, public2: 0, room: 0, mail: 0, membership: 0, badPoint: 0, notCome: 0 };

                const areaBranchData = getBranchesInArea(getAreaSelectedForLoad());
                const mapNameByBranchID = {};
                areaBranchData.forEach(item => {
                    mapNameByBranchID[Number(item.branchID)] = item.name;
                });

                const branchTabPayloads = [];

                requestList.forEach((item, index) => {
                    const branchIDTarget = Number(branchListRequest[index]);
                    const branchNameTarget = mapNameByBranchID[branchIDTarget] || `Branch ${branchIDTarget}`;
                    const currentPayload = item.response?.data;
                    const oldPayload = item.responseOldMonth?.data;
                    const rotenPayload = item.responseRotenSurvey?.data?.filterResult;

                    if (!(currentPayload && currentPayload.status === 1)) {
                        return;
                    }

                    const surveyWithBranch = addBranchMetaToWeekData(currentPayload.survey || {}, branchNameTarget, branchIDTarget);
                    const guestWithBranch = addBranchMetaToWeekData(currentPayload.gestOpinion || {}, branchNameTarget, branchIDTarget);
                    const rotenWithBranch = addBranchMetaToWeekData(rotenPayload || {}, branchNameTarget, branchIDTarget);

                    mergeWeekObject(mergedSurvey, surveyWithBranch);
                    mergeWeekObject(mergedGuestOpinion, guestWithBranch);
                    mergeMetricObject(mergedSumTypeSurvey, currentPayload.sumTypeSurvey || {});

                    const branchPayload = {
                        ...currentPayload,
                        survey: surveyWithBranch,
                        gestOpinion: guestWithBranch,
                        rotenGuestOpinion: rotenWithBranch,
                        oldMonth: (oldPayload && oldPayload.calculatorWeek !== undefined) ? oldPayload : buildEmptyOldMonth(),
                    };

                    branchTabPayloads.push({
                        branchID: branchIDTarget,
                        branchName: branchNameTarget,
                        data: convertPayloadToSurveyView(branchPayload),
                    });
                });

                requestList.forEach((item, index) => {
                    const branchIDTarget = Number(branchListRequest[index]);
                    const branchNameTarget = mapNameByBranchID[branchIDTarget] || `Branch ${branchIDTarget}`;
                    const rotenWithBranch = addBranchMetaToWeekData(item.responseRotenSurvey?.data?.filterResult || {}, branchNameTarget, branchIDTarget);
                    mergeWeekObject(mergedRotenOpinion, rotenWithBranch);
                });

                const averageWeek = buildAverageWeekFromSurvey(mergedSurvey);
                const calculatorWeek = buildCalculatorWeekFromAverage(averageWeek);
                const dataChart = buildChartDataFromCalculator(calculatorWeek);
                const weekReport = validCurrentResponse?.[0]?.weekReport || {};

                const validOldMonthResponse = requestList
                    .map(item => item.responseOldMonth?.data)
                    .filter(item => item && item.status === 1);

                const oldMonthSurvey = { week1: [], week2: [], week3: [], week4: [], week5: [], month: [] };
                validOldMonthResponse.forEach(item => {
                    mergeWeekObject(oldMonthSurvey, item.survey || {});
                });
                const oldAverageWeek = buildAverageWeekFromSurvey(oldMonthSurvey);
                const oldCalculatorWeek = buildCalculatorWeekFromAverage(oldAverageWeek);

                dispatch(hideLoading());
                const areaPayload = {
                    status: 1,
                    survey: mergedSurvey,
                    weekReport,
                    averageWeek,
                    calculatorWeek,
                    gestOpinion: mergedGuestOpinion,
                    rotenGuestOpinion: mergedRotenOpinion,
                    sumTypeSurvey: mergedSumTypeSurvey,
                    dataChart,
                    oldMonth: {
                        calculatorWeek: {
                            Month: oldCalculatorWeek?.Month || buildEmptyOldMonth().calculatorWeek.Month
                        }
                    }
                };

                dispatch(surveyReport.fetchSurveyReport(areaPayload));

                setActiveAreaTab("ALL");
                setTypeView("REPORT");
                setAreaBranchTabs(branchTabPayloads);
                setAreaAllTabData(convertPayloadToSurveyView(areaPayload));
            } catch (error) {
                console.log('Error', error)
            }
        }
        FetchSumData();
        hideLoading();
    }

    function addMultiMonth(value) {
        if (!value) return;
        if (multiMonths.includes(value)) {
            showToast("This month was already added");
            return;
        }
        setMultiMonths([...multiMonths, value].sort());
        setMultiResult(null);
    }

    function removeMultiMonth(value) {
        setMultiMonths(multiMonths.filter(item => item !== value));
        setMultiResult(null);
    }

    function findBranch11() {
        const areas = Object.keys(allBranchInform || {});
        for (const key of areas) {
            const found = (allBranchInform[key] || []).find(item => Number(item.branchID) === 11);
            if (found) return { branchID: 11, branchName: found.name };
        }
        return null;
    }

    function getMultiBranches() {
        if (isLoadAreaMode) {
            const list = getBranchesInArea(getAreaSelectedForLoad())
                .map(item => ({ branchID: Number(item.branchID), branchName: item.name }))
                .filter(item => item.branchID > 0 && item.branchID !== 11);
            if (includeBranch11) {
                const b11 = findBranch11();
                if (b11) list.push(b11);
            }
            return list;
        }
        const id = Number(isMultiBranch ? dataBranchOnState.ID : branchID);
        return id > 0 ? [{ branchID: id, branchName: titleBranch }] : [];
    }

    async function loadMultiMonthData() {
        const branches = getMultiBranches();
        if (multiMonths.length === 0) {
            showToast("Please add at least one month");
            return;
        }
        if (branches.length === 0) {
            showToast("Please select branch or area");
            return;
        }
        setMultiLoading(true);
        try {
            const monthData = {};
            await Promise.all(multiMonths.map(async (month) => {
                monthData[month] = {};
                await Promise.all(branches.map(async (b) => {
                    try {
                        const res = await surveyApi.getNewVersionSurvey(b.branchID, "Month", month, token);
                        const list = res?.data?.status === 1 ? res.data.survey?.month : [];
                        monthData[month][b.branchID] = Array.isArray(list) ? list : [];
                    } catch (err) {
                        monthData[month][b.branchID] = [];
                    }
                }));
            }));
            setMultiResult({
                months: [...multiMonths].sort(),
                monthData,
                branches,
                areaName: isLoadAreaMode ? (areaSelected === "Select Area" ? "Viet Nam" : areaSelected) : titleBranch,
            });
        } finally {
            setMultiLoading(false);
        }
    }

    function renderMultiMonthPanel() {
        return (
            <div className="mb-3 p-3" style={{ border: '1px solid #482979', borderRadius: '6px', background: '#f7f4fb' }}>
                <div className="d-flex align-items-center flex-wrap" style={{ gap: '8px' }}>
                    <strong style={{ color: '#482979', fontSize: '1.4rem' }}>Select months:</strong>
                    <input
                        type="month"
                        className="nav-link-sub"
                        value={multiMonthInput}
                        onChange={e => setMultiMonthInput(e.target.value)}
                    />
                    <button className="btn btn-success" onClick={() => { addMultiMonth(multiMonthInput); setMultiMonthInput(""); }}>
                        + Add month
                    </button>
                    <button className="btn btn-primary" disabled={multiLoading || multiMonths.length === 0} onClick={loadMultiMonthData}>
                        {multiLoading ? "Loading..." : "Create report"}
                    </button>
                    <button className="btn btn-secondary" onClick={() => { setMultiMonths([]); setMultiResult(null); }}>
                        Clear
                    </button>
                    {isLoadAreaMode && (
                        <label className="mb-0 ml-3 d-flex align-items-center" style={{ cursor: 'pointer', fontSize: '1.2rem' }}>
                            <input
                                type="checkbox"
                                className="mr-2"
                                checked={includeBranch11}
                                onChange={e => { setIncludeBranch11(e.target.checked); setMultiResult(null); }}
                            />
                            Include overseas AZ PhnomPenh
                        </label>
                    )}
                </div>
                <div className="d-flex flex-wrap mt-2" style={{ gap: '6px' }}>
                    {multiMonths.length === 0 ? <span style={{ opacity: 0.6 }}>No month selected</span> : multiMonths.map(m => (
                        <span key={m} style={{ background: '#482979', color: 'white', borderRadius: '14px', padding: '4px 14px', fontSize: '1.3rem' }}>
                            {m}
                            <span style={{ marginLeft: '8px', cursor: 'pointer', fontWeight: 700 }} onClick={() => removeMultiMonth(m)}>×</span>
                        </span>
                    ))}
                </div>
            </div>
        );
    }

    function onOpenGuestFeedback(value) {
        alert('' + value);
    }
    function closeModal() {
        const closeModal = actResetModal();
        dispatch(closeModal);
    }

    function handleOpenModalEditSurvey(survey) {
        var changeModal;
        var changeValue = {};
        changeModal = actModalChange("centered",
            "Change Survey", <ModalSupportOption
            title={`Change Survey`}
            button1="Close"
            button2="Confirm Edit"
            typeButton2="btn-warning"
            //   value1={monthMoveTo}
            featureButton1={() => closeModal()}
            featureButton2={() => onUpdateEditSurvey(changeValue)}
            featureSupport1={onChangeValue}
            type={4}
            itemOption={survey}
        />)

        dispatch(changeModal);
        const openModal = actModalIsOk();
        dispatch(openModal);

        function onChangeValue(value, target) {
            changeValue[target] = "";
            changeValue[target] = value;
        }

        const onUpdateEditSurvey = async (dataChange) => {
            // call API update
            const listKey = Object.keys(dataChange);
            if (listKey.length > 0) {
                const changSurveyData = await surveyApi.changeEditNewSurvey(dataBranchOnState.ID, dataChange, survey._id, token);
                if (!changSurveyData) showToast("Error when edit survey");
                else {
                    onLoadData((isMultiBranch ? dataBranchOnState.ID : branchID), dataBranchOnState.date, dataBranchOnState.loadWith);
                    showToast(changSurveyData.data.msg);
                }
            } else showToast("No data has been updated");
            closeModal();
        }
    }

    function handleOpenModalEditSurveyWeek(week) {
        var changeModal;
        changeModal = actModalChange("centered",
            "Change Survey", <ModalSupportOption
            title={`Change Survey Week`}
            typeButton2="btn-warning"
            featureSupport1={() => closeModal()}
            featureSupport2={handleUpdateEditSurveyWeek}

            type={5}
            itemOption={{week,data: surveyOnlineData.content[week] }}
        />)

        dispatch(changeModal);
        const openModal = actModalIsOk();
        dispatch(openModal);

       function handleUpdateEditSurveyWeek(data,listSelect)  {
            const updateSurvey = async () => {
                const response = await surveyApi.changeEditNewSurveyWeek(dataBranchOnState.ID, {
                    data,
                    listSelect,
                    week,
                    date: dataBranchOnState.date,
                }, token);

                if (!response) showToast("Error when edit survey");
                else {
                    onLoadData((isMultiBranch? dataBranchOnState.ID : branchID), dataBranchOnState.date, dataBranchOnState.loadWith);
                    showToast(response.data.msg);
                    closeModal();
                }
            }
            updateSurvey();
        //    const dataResult = await surveyApi
        }

    }

    function updateNoteToServer(value, survey, week, index, type) {
        if (value !== survey.supFeedback && type ==="survey") {
            const dataUpdate = { value, survey }
            const updateNote = async () => {
                const response = await surveyApi.updateNoteNewSurvey(dataBranchOnState.ID, dataUpdate, dataBranchOnState.date, token);
                if (response !== undefined) {
                    if (response.data !== undefined) {
                        showToast(response.data.msg);
                        // change on Reducer
                        dispatch(surveyReport.changeNoteChangeNewSurveyReport({ value, week, index }));
                    }
                }
            }
            updateNote();
        }

        if (value !== survey.supFeedback && type ==="roten") {
            const dataUpdate = { value, survey }
            const updateNote = async () => {
                const response = await rotenSurveyApi.updateNoteSupFeedBack(dataBranchOnState.ID, dataUpdate, token);
                if (response !== undefined) {
                    if (response.data !== undefined) {
                        showToast(response.data.msg);
                        // change on Reducer
                        dispatch(surveyReport.changeSupFeedBackRotenSurveyReport({ value, week, index }));
                    }
                }
            }
            updateNote();
        }
    }

    function openModal(type, title, content, btn1, btn2) {
        const changeModal = actModalChange(type, title, content, btn1, btn2);
        dispatch(changeModal);

        const actOpen = actModalIsOk();
        dispatch(actOpen);
    }

    function branchIdToName() {
        var findindexBranchName;
        const listBranch = Object.keys(allBranchInform);
        if (allBranchInform[area] !== undefined) {
            if (isMultiArea) {
                listBranch.forEach(branchName => {
                    const testFind = allBranchInform[branchName].findIndex(({ branchID }) => branchID === Number(dataBranchOnState.ID))
                    if (testFind !== -1) {
                        findindexBranchName = testFind;
                        selectArea = branchName;
                        setSelectArea(branchName);
                    };
                });
                return allBranchInform[selectArea][findindexBranchName].name
            } else {
                findindexBranchName = allBranchInform[area].findIndex(({ branchID }) => branchID === Number(dataBranchOnState.ID));
                return allBranchInform[area][findindexBranchName].name
            }
        }
    }

    function changeDateReport(value) {
        saveDataToDatePickUp = {
            ...dataBranchOnState,
            date: value
        }
        dispatch(datePickup.changeSelectBranchSurveyOnline(saveDataToDatePickUp))
    }

    const showToast = (content) => {
        return toast.info(content, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    function onClickDownloadExcel() {
        const currentContext = getCurrentAreaTabData();
        if (isLoadAreaMode && Number(currentContext.branchID) === 0) {
            showToast("Please choose a branch tab to download excel.");
            return;
        }

        // call API
        const makeExcel = async () => {
            try {
                const result = await surveyApi.surveyExcel(
                    isLoadAreaMode ? Number(currentContext.branchID) : (isMultiBranch ? dataBranchOnState.ID : branchID),
                    currentContext.data.content,
                    dataBranchOnState.loadWith,
                    dataBranchOnState.date,
                    token);
                const url = window.URL.createObjectURL(new Blob([result.data]));
                const link = document.createElement('a');
                link.href = url;
                // const nameToBranch = branchIdToName();
                link.setAttribute('download', `${coverNameToID(dataBranchOnState.ID)}_Month_${dataBranchOnState.date}_SurveyResult.xlsx`); //or any other extension
                document.body.appendChild(link);
                link.click();
                alert(result.data.msg === undefined ? "Success download Excel File" : result.data.msg);

            } catch (error) {
                alert(error.message);
            }
        }
        makeExcel();
    }

    function sendSurveyReport() {
        if (isLoadAreaMode) {
            showToast("Area mode does not support send report.");
            return;
        }

        // save id = chartSurvey to img
        const makeChartSurvey = async () => {
            await surveyApi.makeChartSurvey(surveyOnlineData.dataChart, token);
        }
        makeChartSurvey();

        const changeModal = actModalChange("centered",
            "Confirm Send Report", "Please complete information: ", "", "")
        dispatch(changeModal);

        const openModal = actModalIsOk();
        dispatch(openModal);

        const changeComponent = actComponentsModal(<ModalSurveySentReport
            onConfirmSentMailMonth={onConfirmSentMailMonth}
            onSentReport={onSentReport}
            closeModal={closeModal} />)
        dispatch(changeComponent);
    }

    function onConfirmSentMailMonth(inputData) {
        if (window.confirm("You want use REPORT SURVEY MONTH?\nThis report sent all mail to Azumaya")) {
            onSentReport(inputData)
        }
    }

    function onSentReport(inputData) {
        showLoading();
        dispatch(surveyReport.changeInforSendReport(inputData));
        const { maker, note, sendReportDate } = inputData;
        const dataReport = {
            ...surveyOnlineData,
            monthReport: dataBranchOnState.date,
            "maker": maker.trim(),
            "note": note.trim(),
            calculatorWeek: surveyOnlineData.calculatorWeek,
            sendReportDate,
            oldMonth: surveyOnlineData.oldMonth,
        };

        const sendReport = async () => {
            const check = await surveyApi.sendMailReport(dataReport, token);
           showToast(check.data === undefined ? "Error Send Mail" : check.data.msg)
        }

        sendReport();
        hideLoading();
        closeModal()
    }

    function renderTotalTitle(target, viewData) {
        if (!viewData?.weekReport?.[target] || !viewData?.content?.[target]) return "";
        return (<div className="d-flex survey-total-title_detail" style={{ border: '1px solid black' }}>
            <h3 className="survey-total-title_detail-week">{target.toUpperCase()} </h3>
            <div className="survey-total-title_detail-content">
                <h4>* Start: {SupportDate.changeDataFullFormat("" + viewData.weekReport[target].start)}</h4>
                <h4>* End: {SupportDate.changeDataFullFormat("" + viewData.weekReport[target].end)}</h4>
                <h4>Count: {Object.keys(viewData.content[target]).length}</h4>
            </div>
        </div>
        )
    }

    const isLoadAreaMode = isMultiBranch && dataBranchOnState.branch === "Select Branch";
    const isAreaAllMode = isLoadAreaMode && activeAreaTab === "ALL";
    const areaSelected = getAreaSelectedForLoad();
    const loadPathTarget = isLoadAreaMode
        ? `area_${encodeURIComponent(areaSelected)}`
        : (isMultiBranch ? dataBranchOnState.ID : branchID);
    const titleBranch = isLoadAreaMode ? `${areaSelected} (All Branches)` : (isMultiBranch ? selectBranch : auth.user.branch);

    const currentAreaContext = getCurrentAreaTabData();
    const currentViewData = currentAreaContext.data || surveyOnlineData;
    const titleWithTab = isLoadAreaMode
        ? (activeAreaTab === "ALL"
            ? `${areaSelected} (All Branches)`
            : `${areaSelected} - ${areaBranchTabs.find(item => String(item.branchID) === String(activeAreaTab))?.branchName || ""}`)
        : titleBranch;

    useEffect(() => {
        if (!isAreaAllMode && typeView === "FEEDBACK") {
            setTypeView("REPORT");
        }
    }, [isAreaAllMode, typeView]);

    return (
        <React.Fragment>
            <ModalNotify closeModal={closeModal} />
            <ul className="nav nav-sub row_freeze" id="test1">
                <MultiBranchSelect
                    listArea={listArea}
                    listBranch={listBranch}
                    changeSelectArea={changeSelectArea}
                    changeSelectBranchID={changeSelectBranchID}
                    selectArea={dataBranchOnState.area}
                    selectBranch={dataBranchOnState.branch}
                />
                <li className="nav-item-sub">
                    <input
                        // disabled={Items.length > 0}
                        type="month"
                        className="nav-link-sub"
                        href="#"
                        onChange={e => changeDateReport(e.target.value)}
                        value={dataBranchOnState.date}
                    />
                </li>
                <li className="rp__title ">
                    <Link
                        className="nav-item-sub btn_load_data"
                        id="modal_inputdata"
                        //nameBranchToBranchID()
                        to={`/survey_online/${loadPathTarget}/${dataBranchOnState.date}`}
                        onClick={() => onLoadData((isMultiBranch ? dataBranchOnState.ID : branchID), dataBranchOnState.date, 'month')}
                    >
                        Load Data
                    </Link>
                </li>

                <h1 className="rp__title"
                    style={{
                        minWidth: '500px',
                        marginLeft: '32px'
                    }}
                    id="rcSum_title">
                    {multiMode
                        ? `${isLoadAreaMode ? `${areaSelected} (All Branches)` : titleBranch} - Survey Online : ${multiMonths.length ? multiMonths.join(", ") : "(no month)"}`
                        : `${titleWithTab} - Survey Online : ${SupportDate.changeDataToYYYY_MMMM(dataBranchOnState.date)}`}
                </h1>
                {role === 7 && <li className="rp__title">
                    <button className={multiMode ? "btn btn-warning" : "btn btn-info"} style={{ marginLeft: '16px' }}
                        onClick={() => setMultiMode(!multiMode)}>
                        {multiMode ? "Back to Month Report" : "Multi-Month Report"}
                    </button>
                </li>}
            </ul>
            <div>-----------------------------------</div>

            {multiMode ? renderMultiMonthPanel() : ""}

            {
                !multiMode && isLoadAreaMode && areaBranchTabs.length > 0 ?
                    <div className="nav nav-tabs nav-fill mb-3" role="tablist">
                        <span
                            className="nav-item nav-link"
                            onClick={() => {
                                setActiveAreaTab("ALL");
                                setTypeView("REPORT");
                            }}
                            style={{ cursor: "pointer", opacity: activeAreaTab === "ALL" ? "1" : "0.6", background: '#3d11fd' }}
                        >
                            All
                        </span>
                        {
                            areaBranchTabs.map(item => (
                                <span
                                    key={item.branchID}
                                    className="nav-item nav-link"
                                    onClick={() => setActiveAreaTab(String(item.branchID))}
                                    style={{ cursor: "pointer", opacity: String(activeAreaTab) === String(item.branchID) ? "1" : "0.6", background: '#2e55ff' }}
                                >
                                    {item.branchName}
                                </span>
                            ))
                        }
                    </div>
                    : ""
            }

            {/* Show Information Week1 star,end, count */}
            {
                multiMode ? (multiResult ? <MultiMonthStatistic {...multiResult} /> : "") :
                Object.keys(currentViewData.content || {}).length === 0 ? <div className="mt-5"><NoteReport /></div> :
                    <>
                        <div className="d-flex survey-total-title mb-2">
                            <div className="survey-total-title_month" style={{ border: '1px solid black' }}>
                                <span className="survey-total-title_month-text">Total Month Surveys: </span>
                                <span className="survey-total-title_month-number">{Object.keys(currentViewData.content.month || {}).length}</span>
                            </div>
                            {renderTotalTitle("week1", currentViewData)}
                            {renderTotalTitle("week2", currentViewData)}
                            {renderTotalTitle("week3", currentViewData)}
                            {renderTotalTitle("week4", currentViewData)}
                            {currentViewData?.weekReport?.week4?.end === currentViewData?.weekReport?.week5?.end ? "" : renderTotalTitle("week5", currentViewData)}
                        </div>

                        <div className="nav nav-tabs nav-fill survey_report_select mb-3" role="tablist">
                            <span className="nav-item nav-link survey_report_select-item"
                                onClick={() => setTypeView("RESULT")}
                                style={{ backgroundColor: '#482979', cursor: "pointer", opacity: typeView === "RESULT" ? "1" : "0.5" }}>
                                Survey Result</span>
                            <span className="nav-item nav-link survey_report_select-item"
                                onClick={() => setTypeView("REPORT")}
                                style={{ backgroundColor: '#482979', cursor: "pointer", opacity: typeView === "REPORT" ? "1" : "0.5" }}>
                                Survey Statistic</span>
                            {isAreaAllMode ?
                                <span className="nav-item nav-link survey_report_select-item"
                                    onClick={() => setTypeView("FEEDBACK")}
                                    style={{ backgroundColor: '#482979', cursor: "pointer", opacity: typeView === "FEEDBACK" ? "1" : "0.5" }}>
                                    Guest Feedback</span>
                                : ""}
                            <span className="nav-item nav-link survey_report_select-item"
                                onClick={() => setTypeView("ROTEN")}
                                style={{ backgroundColor: '#482979', cursor: "pointer", opacity: typeView === "ROTEN" ? "1" : "0.5" }}>
                                Roten Opinion</span>
                            {/* <span className="nav-item nav-link survey_report_select-item"
                                onClick={() => setTypeView("BREAKFAST")}
                                style={{ backgroundColor: '#482979', cursor: "pointer", opacity: typeView === "BREAKFAST" ? "1" : "0.5" }}>
                                Breakfast Opinion</span> */}
                        </div>

                        {/* {
                            isAreaAllMode ?
                                <div style={{ fontWeight: '600', marginBottom: '10px', color: '#482979' }}>
                                    Area + All mode: Survey Statistic hiển thị mặc định toàn bộ thống kê Question 1 → 7 và bảng theo từng chi nhánh + tổng area.
                                </div>
                                : ""
                        } */}

                        {
                            (currentViewData.isLoading === false && typeView === "RESULT") ? <>
                                <NewSurveyOnlineItems
                                    role={isLoadAreaMode ? -1 : role}
                                    items={currentViewData.content}
                                    averageWeek={currentViewData.averageWeek}
                                    calculatorWeek={currentViewData.calculatorWeek}
                                    weekReport={currentViewData.weekReport}
                                    onOpenGuestFeedback={onOpenGuestFeedback}
                                    handleOpenModalEditSurvey={handleOpenModalEditSurvey}
                                    handleOpenModalEditSurveyWeek={handleOpenModalEditSurveyWeek}
                                    loadWith={dataBranchOnState.loadWith}
                                />

                                <button
                                    className={isLoadAreaMode && Number(currentAreaContext.branchID) === 0 ? "op-hidden" : "btn btn__footer btn-light d-flex ml-5"}
                                    onClick={() => onClickDownloadExcel()}
                                >
                                    <FontAwesomeIcon icon={faSave} className="btn__add_icon icon mr-2" />
                                    <span className="btn__add_text mr-3">DOWN LOAD EXCEL FILE</span>
                                </button >
                            </>
                                : ""
                        }
                        {
                            (currentViewData.isLoading === false && typeView === "REPORT") ?
                                <>
                                    <NewSurveyOnlineReport
                                        branchID={Number(currentAreaContext.branchID || dataBranchOnState.ID)}
                                        averageWeek={currentViewData.averageWeek}
                                        guestOpinion={currentViewData.gestOpinion}
                                        items={currentViewData.content}
                                        calculatorWeek={currentViewData.calculatorWeek}
                                        weekReport={currentViewData.weekReport}
                                        onOpenGuestFeedback={onOpenGuestFeedback}
                                        loadWith={dataBranchOnState.loadWith}
                                        dataChart={currentViewData.dataChart}
                                        oldMonth={currentViewData.oldMonth}
                                        sumTypeSurvey={currentViewData.sumTypeSurvey}
                                        updateNoteToServer={updateNoteToServer}
                                        role={isLoadAreaMode ? -1 : role}
                                        checkSend={checkSend}
                                        isAreaAllMode={isAreaAllMode}
                                        areaBranchTabs={areaBranchTabs}
                                        areaName={areaSelected}
                                        mode={isAreaAllMode ? "statistic" : "report"}
                                    />
                                    <button
                                        className={(role === 3 && checkSend && !isLoadAreaMode) ? "btn btn__footer btn-light d-flex ml-5 " : "op-hidden"}
                                        onClick={() => sendSurveyReport()}
                                    >
                                        <FontAwesomeIcon icon={faSave} className="btn__add_icon icon mr-2" />
                                        <span className="btn__add_text mr-3">SEND REPORT</span>
                                    </button >
                                </>
                                : ""
                        }
                        {
                            (currentViewData.isLoading === false && typeView === "FEEDBACK" && isAreaAllMode) ?
                                <NewSurveyOnlineReport
                                    branchID={Number(currentAreaContext.branchID || dataBranchOnState.ID)}
                                    averageWeek={currentViewData.averageWeek}
                                    guestOpinion={currentViewData.gestOpinion}
                                    items={currentViewData.content}
                                    calculatorWeek={currentViewData.calculatorWeek}
                                    weekReport={currentViewData.weekReport}
                                    onOpenGuestFeedback={onOpenGuestFeedback}
                                    loadWith={dataBranchOnState.loadWith}
                                    dataChart={currentViewData.dataChart}
                                    oldMonth={currentViewData.oldMonth}
                                    sumTypeSurvey={currentViewData.sumTypeSurvey}
                                    updateNoteToServer={updateNoteToServer}
                                    role={isLoadAreaMode ? -1 : role}
                                    checkSend={checkSend}
                                    isAreaAllMode={isAreaAllMode}
                                    areaBranchTabs={areaBranchTabs}
                                    areaName={areaSelected}
                                    mode="feedback"
                                />
                                : ""
                        }
                        {
                            (currentViewData.isLoading === false && typeView === "ROTEN") ? 
                                <RotenSurveyReport 
                                    guestOpinion={currentViewData.rotenGuestOpinion}
                                    checkSend={checkSend}
                                    role={isLoadAreaMode ? -1 : role}
                                    updateNoteToServer={updateNoteToServer}
                                />
                                :""
                        }
                    </>
            }
        </React.Fragment >
    );
}

export default NewSurveyOnline;
